<template>
  <div class="head">
    <img src="./../../public/head.jpg" alt="">
    <div class="nav">
      <ul>
        <span v-if="status" class="user_color">欢迎会员<span>{{user_name}}</span></span>
        <a class="home_link" href="/">首页</a>
        <router-link to="/main" tag="li" :class="[$route.path==='/main'?'option':'']">资源列表</router-link>
        <router-link to="/query" tag="li" :class="[$route.path==='/query'?'option':'', 'pharma_class']">全文数据库
          <span class="new_b">
            new
          </span>
        </router-link>
        <router-link to="/pharma" tag="li" :class="[$route.path==='/pharma'?'option':'']">药典数据库
        </router-link>
        <router-link to="/pay" tag="li" :class="[$route.path==='/pay'?'option':'']">充值与续费</router-link>
        <router-link to="/memberinfo" tag="li" :class="[$route.path==='/memberinfo'?'option':'']">
          会员信息
        </router-link>
        <router-link to="/memberedit" tag="li" :class="[$route.path==='/memberedit'?'option':'']">
          修改资料
        </router-link>
        <router-link v-if="!status" to="/login" tag="li" :class="[$route.path==='/login'?'option':'',
                    $route.path==='/register'?'option':'',
                    $route.path==='/retrieve'?'option':'',
                    ]">
          登录/注册
        </router-link>
        <li v-if="status" @click="quit">退出系统</li>
      </ul>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'

  export default {
    data() {
      return {
        status: false,
        user_name: null,
        valNum: null,
        infoList: [],
        show_detail: false,
        loading: true
      }
    },
    created() {
      this.user_name = localStorage.getItem("user_info")
      this.Judge_state();
      // 接收发布者传来的消息
      this.bus.$on('change', (msg) => {
        this.status = msg;
      });
      // 获取新消息列表
      // this.getInfoList()
    },
    methods: {
      // 获取消息列表
      // getInfoList() {
      //   this.$http.getNewInfoList().then(resp => {
      //     this.valNum = resp.count
      //     this.infoList = resp.data
      //     this.loading = false
      //   }).catch(err => {
      //     console.log(err)
      //   })
      // },
      // 判断状态
      Judge_state() {
        if (this.$router.status) {
          this.status = true;
          this.user_name = localStorage.getItem("user_info")
        } else {
          this.status = false;
        }
      },
      // 点击退出
      quit() {
        this.$confirm('您将退出账户，请确认', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 删除本地的token
          this.$http.getLogout().then(res => {
            localStorage.removeItem('login_info');
            setTimeout(()=>{
              this.$router.push({path: '/login'})
            },100)
            //  提示信息
            this.$message({
              message: '退出成功',
              type: 'success',
              customClass: 'hint-message',
              center: true
            });
            this.$router.status = false;
          })
          // 跳转到登陆页面
        }).catch(() => {
        });
      },
      // showDetail(key) {
      //   key.state = !key.state
      //   let param = new URLSearchParams()
      //   param.append("n_id", key.id)
      //   if (key.flag === 'n') {
      //     this.$http.postReadState(param).then(resp => {
      //       if (resp.code === 200) {
      //         this.getInfoList()
      //       }
      //     }).catch(err => {
      //       console.log(err)
      //     })
      //   }
      //   key.flag = 'y'
      // },
      // hide() {
      //   this.infoList = this.infoList.map(item => {
      //     item.state = false
      //     return item
      //   })
      //   this.close_state()
      // },
      // show() {
      //   this.loading = true
      //   this.getInfoList()
      // },
      close_state() {
        this.$http.getClosePopoverEvent().then(res => {
        }).catch(err => {
          console.log(err, 'err')
        })
      }
    },
    watch: {
      $route(to, from) {
        this.Judge_state()
        // 获取新消息列表
        // this.getInfoList()
      }
    }
  }
</script>
<style scoped>
  /*.add_time {*/
  /*  text-align: right;*/
  /*}*/

  .head {
    text-align: center;
  }

  .head img {
    /* height: 100%; */
    margin-bottom: -5px;
  }

  .nav {
    width: 1030px;
    margin: 0 auto;
  }

  ul {
    height: 32px;
    padding: 0 100px;
    display: flex;
    align-items: center;
    background-color: #6BA2C0;
    text-align: center;
  }

  li {
    flex: 1;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
  }

  .option {
    color: #A7231E;
  }

  li:hover {
    color: #A7231E;
  }

  .user_color {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
  }

  .user_color span {
    color: yellow;
  }

  .icon_badge {
    padding: 0 10px 0 15px;
    font-size: 17px;
    color: rgb(255, 255, 255);
  }

  .icon_badge:hover {
    color: yellow;
  }

  .head >>> .el-badge__content.is-fixed {
    top: 3px;
    right: 20px;
  }

  .head >>> .el-badge__content {
    height: 12px;
    line-height: 12px;
  }

  .list_wrap {
    max-height: 300px;
    overflow: auto;
  }

  /* .title {
      font-size: 14px;
      padding: 10px 15px;
      border-bottom: 1px solid #ebebeb;
  } */
  .list_item {
    padding: 16px;
    border-bottom: 1px solid #ebebeb;
  }

  .open_detail {
    font-size: 12px;
    color: #999;
    float: right;
  }

  .icon_new {
    display: inline-block;
    background-color: tomato;
    width: 7px;
    height: 7px;
    border-radius: 50%;
    position: absolute;
    left: 24px;
    opacity: .8;
  }

  .detail_text {
    padding: 10px 0 0;
    font-size: 12px;
    color: #777;
    line-height: 22px;
  }

  .detail_text:hover {
    color: yellowgreen;
  }
  .home_link {
    color: #fff;
    font-weight: 600;
    font-size: 14px;
    text-decoration: none;
    padding: 0 12px;
  }
  .home_link:hover{
    color: #A7231E;
  }
  .pharma_class {
    position: relative;
  }
  .new_b {
    position: absolute;
    bottom: 18px;
    right: -10px;
    color: #A7231E;
    padding: 0px 2px;
    font-size: 10px;
    background-color: #FFCE60;
    border-radius: 4px 0;
  }
</style>
